module.exports = __webpack_public_path__ + "statics/img/default_themes.a8493b32.png";